// Thai address master search — extracted from OrderFormQuick.vue (spec
// 2026-10-14 §5.3) so the recipient edit dialog uses the same lookup.
//
// `list` is the `Order/getAddress` store list (rows shaped
// { DistrictID, District, CityID, City, ProvinceID, Province, Zipcode }).
// The query is "ตำบล|รหัสไปรษณีย์ [อำเภอ [จังหวัด]]", split on single spaces,
// exactly as the quick order form always matched it.

export const ADDRESS_SEARCH_LIMIT = 15;

export function filterThaiAddresses(list, query, limit = ADDRESS_SEARCH_LIMIT) {
  const rows = Array.isArray(list) ? list : [];
  const key = String(query == null ? '' : query).split(' ');
  const has = (s, k) => String(s == null ? '' : s).includes(k);
  const result = rows.filter(item => {
    if (!item) return false;
    const first = has(item.District, key[0]) || item.Zipcode == key[0];
    if (key.length === 1) return first;
    if (key.length === 2) return first && has(item.City, key[1]);
    if (key.length === 3) return first && has(item.City, key[1]) && has(item.Province, key[2]);
    return false;
  });
  return result.slice(0, limit);
}

/** The order's recipient_* fields for one master row. */
export function addressFieldsFromMaster(r) {
  const row = r || {};
  return {
    recipient_address_district_id: row.DistrictID,
    recipient_address_city_id: row.CityID,
    recipient_address_province_id: row.ProvinceID,
    recipient_address_district: row.District,
    recipient_address_city: row.City,
    recipient_address_province: row.Province,
    recipient_zipcode: row.Zipcode
  };
}

/** One suggestion line (Bangkok uses แขวง/เขต, elsewhere ต./อ./จ.). */
export function thaiAddressLabel(r) {
  const row = r || {};
  if (Number(row.ProvinceID) === 1) {
    return `แขวง${row.District} เขต${row.City} จังหวัด${row.Province} ${row.Zipcode}`;
  }
  return `ต.${row.District} อ.${row.City} จ.${row.Province} ${row.Zipcode}`;
}

export default { ADDRESS_SEARCH_LIMIT, filterThaiAddresses, addressFieldsFromMaster, thaiAddressLabel };
